import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={25} fill='none' {...props}>
    <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M6 11.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10M6 8.5v-2M6 4.5h.005' />
    </g>
  </svg>
);
export default SvgInfo;
